import { Link } from "react-router-dom";
import { Zap } from "lucide-react";
import { thumbUrl } from "@/lib/media";

export const ProductCard = ({ product }) => {
  return (
    <Link
      to={`/product/${product.id}`}
      data-testid={`product-card-${product.id}`}
      className="product-card bg-white border border-stone-200 overflow-hidden group"
    >
      <div className="relative aspect-square overflow-hidden">
        <img
          src={thumbUrl(product.image_url)}
          alt={product.name}
          loading="lazy"
          className="product-card-image w-full h-full object-cover"
        />
        <div className="absolute top-3 left-3 flex flex-col gap-1">
          {product.is_new && <span className="badge-new">New</span>}
          {product.is_featured && <span className="badge-featured">Featured</span>}
          {product.product_type === "digital" && (
            <span
              data-testid={`digital-badge-${product.id}`}
              className="inline-flex items-center gap-1 bg-deep-moss text-white text-xs font-medium px-2 py-0.5 rounded"
            >
                            <Zap className="w-3 h-3" /> Instant Download
            </span>
          )}
        </div>
      </div>
      <div className="p-4">
        <p className="font-accent text-xs text-stone-500 uppercase tracking-widest mb-1">
          {product.category.replace("-", " ")}
        </p>
        <h3 className="font-serif text-lg font-medium text-stone-900 mb-2 group-hover:text-deep-moss transition-colors">
          {product.name}
        </h3>
        <p className="font-sans text-deep-moss font-semibold">
          ${product.price.toFixed(2)}
        </p>
      </div>
    </Link>
  );
};
